export default "__VITE_ASSET__B1DJS0M3__"